module.exports = __webpack_public_path__ + "img/interpackmaxi_cod_k.6054fff2.png";